import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { Section, EmptyState, MiniStat, chartTooltip } from "./Section";
import { Heatmap } from "./Heatmap";
import { DEFINITIONS, GROUP_META, fmtNum, fmtPct } from "./definitions";

const label = (d) => new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

export const VolumeSection = ({ data }) => {
  const { kpis, volume, heatmap, settings } = data;
  const series = volume.series.map((p) => ({ ...p, label: label(p.date) }));
  const ooh = heatmap.filter((c) => c.out_of_hours);
  const oohTotal = ooh.reduce((s, c) => s + c.total, 0);
  const oohResolved = ooh.reduce((s, c) => s + c.ai_resolved, 0);
  return (
    <Section title="Volume & coverage" testId="volume-section" info={[DEFINITIONS.coverage, DEFINITIONS.ai_resolved, DEFINITIONS.ai_assisted, DEFINITIONS.human_only]}
      subtitle={`${volume.granularity === "week" ? "Weekly" : "Daily"} conversations by group`}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
        <MiniStat label="AI coverage" value={fmtPct(kpis.ai_coverage)} hint={`${fmtNum(kpis.ai_handled)} of ${fmtNum(kpis.total_tickets)}`} testId="stat-ai-coverage" />
        <MiniStat label="All conversations" value={fmtNum(kpis.total_tickets)} testId="stat-total-conversations" />
        <MiniStat label="Out-of-hours" value={fmtNum(oohTotal)} hint={`outside ${settings.business_hours_start}:00–${settings.business_hours_end}:00 & weekends`} testId="stat-out-of-hours" />
        <MiniStat label="AI-resolved out of hours" value={fmtNum(oohResolved)} hint={oohTotal ? `${fmtPct(Math.round((oohResolved / oohTotal) * 1000) / 10)} of out-of-hours` : ""} testId="stat-ooh-resolved" />
      </div>
      {kpis.total_tickets === 0 ? <EmptyState message="No conversations in this period." testId="volume-empty" /> : (
        <>
          <div className="h-[260px]" data-testid="volume-chart">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={series}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="label" tick={{ fontSize: 11 }} interval="preserveStartEnd" />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip contentStyle={chartTooltip} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                {["ai_resolved", "ai_assisted", "human_only", "open"].map((g) => (
                  <Line key={g} type="linear" dataKey={g} name={GROUP_META[g].label} stroke={GROUP_META[g].color} strokeWidth={2} dot={false}
                    strokeDasharray={g === "open" ? "4 4" : undefined} />
                ))}
              </LineChart>
            </ResponsiveContainer>
          </div>
          <p className="text-sm font-medium text-slate-700 mt-6 mb-2">Conversations by hour and day ({settings.timezone})</p>
          <Heatmap cells={heatmap} />
        </>
      )}
    </Section>
  );
};
